let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dSgGr"), load("c5uOY"), load("6cVEd")]).then(() => parcelRequire('bSBwg'));